/* TODO: t() */
import React from 'react';
import FormElementBase from '../FormElementBase';

import FieldEditor from './MarketSelectorElement/MarketSelectorFieldEditorView';
import FormView, {
  MarketSelectorFormViewProps,
} from './MarketSelectorElement/MarketSelectorFormView';
import ReadOnlyView from './MarketSelectorElement/MarketSelectorReadOnlyView';
import EditView from './MarketSelectorElement/MarketSelectorEditView';

import IndexedList from '../../../support/shared/IndexedList';
import { Market } from '../../../types/shared/Market';
import { MarketSelectorElementDefinition } from '../../../types/shared/FormFieldDefinition';
import { MarketDates, Field } from '../../../types/shared/Vendor';

export type MarketDateSelections = {
  [key: string]: { market: Market; date: string };
};

type ReadOnlyViewProps = {
  isAdmin: boolean;
  value: ObjectOf<Array<string>> | null | undefined;
  // onFileClick: (file: FileDesc, event: Event) => void;
  isLoading: boolean;
  markets: IndexedList<Market>;
  fields: IndexedList<Field>;
};

type FormViewProps = Omit<MarketSelectorFormViewProps, 'definition'> & {
  ref?: React.Ref<FormView>;
};

type EditViewProps = {
  value?: MarketDates;
  onChange: (id: string, value: MarketDates) => void;
  isLoading: boolean;
  markets: IndexedList<Market>;
  selections: MarketDateSelections;
  invoiceView?: boolean;
};

class MarketSelectorElement extends FormElementBase {
  static getType() {
    return 'MarketSelectorElement';
  }

  static getDescription() {
    return 'Market Selector';
  }

  static getAttributes() {
    return {
      name: 'Markets',
      label: 'Choose Markets',
      hidden: false,
      is_required: false,
      is_public: false,
      disableSelectAll: false,
      calendarView: false,
      hiddenInForm: false,
    };
  }

  renderFieldEditor() {
    return <FieldEditor key={this.id} ref="field-editor" parent={this} />;
  }

  renderFieldView(props?: {
    markets?: IndexedList<Market> | null | undefined;
  }) {
    let { markets } = props || {};
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as MarketSelectorElementDefinition}
        markets={markets}
        readOnly={true}
      />
    );
  }

  renderFormView(props: FormViewProps = {}) {
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as MarketSelectorElementDefinition}
        {...props}
      />
    );
  }

  renderReadOnlyView(props: ReadOnlyViewProps) {
    let { isAdmin, value } = props;
    return (
      <ReadOnlyView
        key={this.id}
        definition={this.definition as MarketSelectorElementDefinition}
        isAdmin={isAdmin}
        value={value ?? {}}
      />
    );
  }

  renderEditView(props: EditViewProps) {
    // Ensure we don't pass `null` for value (actually, undefined would be fine).
    if (props.value == null) {
      props = { ...props, value: {} };
    }
    if (props.invoiceView) {
      return (
        <EditView
          key={this.id}
          definition={this.definition as MarketSelectorElementDefinition}
          {...props}
        />
      );
    }

    // TODO: Replace ref={this.id} (was removed for functional component)
    return (
      <EditView
        key={this.id}
        definition={this.definition as MarketSelectorElementDefinition}
        {...props}
      />
    );
  }
}

export default MarketSelectorElement;
